import Vue from 'vue';
import Vuex from 'vuex';
import app from '@/main';


import MasterData from './master_data';
// import MasterData from './master_data';
import VdoSet from '@/store/modules/vdo-set/vdo-set/index';
import VdoSetUnit from '@/store/modules/vdo-set/vdo-set-unit/index';
import VdoSetTopic from '@/store/modules/vdo-set/vdo-set-topic/index';
import BunnyUpload from '@/store/modules/vdo-set/bunny-upload/index';
import CommonData from '@/store/modules/common-data/index';
import Profile from '@/store/modules/profile';
import Courses from '@/store/modules/courses';
import StudentEnroll from '@/store/modules/student-enroll';
import StudentEnrollDetail from '@/store/modules/student-enroll-detail';
import ClassRoomType from '@/store/modules/class-room/class-room-type/index';
import ClassRoomOwned from '@/store/modules/class-room/class-room-owned/index';
import ClassRoom from '@/store/modules/class-room/class-room/index';
import Subject from '@/store/modules/common-data/subject/index';
import SubjectGroup from '@/store/modules/common-data/subject-group/index';
import Degree from '@/store/modules/common-data/degree/index';
import Faculty from '@/store/modules/common-data/faculty/index';
import Department from '@/store/modules/common-data/department/index';
import Curriculum from '@/store/modules/common-data/curriculum/index';
import Prefix from '@/store/modules/common-data/prefix/index';
import Project from '@/store/modules/common-data/project/index';
import Assessment from '@/store/modules/common-data/assessment/index';
import StudentStatus from '@/store/modules/common-data/student-status/index';
import Student from '@/store/modules/profile/student/index';
import Teacher from '@/store/modules/profile/teacher/index';
import Staff from '@/store/modules/profile/staff/index';
import CourseOutline from '@/store/modules/courses/course-outline/index';
import CourseOutlineAssessment from '@/store/modules/courses/course-outline-assessment/index';
import CourseOutlineUnit from '@/store/modules/courses/course-outline-unit/index';
import CourseOutlineRegistration from '@/store/modules/courses/course-outline-registration/index';
import AcademicPeriod from '@/store/modules/common-data/academic-period/index';
import AcademicPeriodConfig from '@/store/modules/common-data/academic-period-config/index';
import ZoneGroup from '@/store/modules/common-data/zone-group/index';
import ClassSection from '@/store/modules/courses/class-section/index';
import LiveClassSchedule from '@/store/modules/live-class/live-class-schedule/index';
import VdoLiveSet from '@/store/modules/live-class/vdo-live-set/index';
import VdoLiveSetTopic from '@/store/modules/live-class/vod-live-set-topic/index';
import Exam from '@/store/modules/examination/exam/index';
import ExamQuestion from '@/store/modules/examination/exam-question/index';
import ExamQuestionType from '@/store/modules/examination/exam-question-type/index';
import Upload from '@/store/modules/upload/index';
import User from '@/store/modules/user';
import AdvisorOnlineSchedule from '@/store/modules/advisor-online-schedule/index';
import InfoGroup from '@/store/modules/university-news/info-group';
import InfoTopic from '@/store/modules/university-news/info-topic';
import YeaLinkImportDate from '@/store/modules/yea-link-import-data/index';
import SystemConfig from '@/store/modules/system/system-config/index';
import Me from './modules/system/me';
import VdoMigration from './modules/system/vdo-migration';

import state from "./modules/theme/state"
import getters from "./modules/theme/getters"
import mutations from "./modules/theme/mutations"
import actions from "./modules/theme/actions"

Vue.use(Vuex);

export default new Vuex.Store({
  getters,
  state,
  mutations:
    {
      changeLang(state, payload) {
        app.$i18n.locale = payload;
        localStorage.setItem('currentLanguage', payload)
      }, ...mutations
    },
  actions: {
    setLang({commit}, payload) {
      commit('changeLang', payload)
    },
    ...actions
  },
  modules: {
    MasterData,
    // MasterData,
    VdoSet,
    VdoSetUnit,
    VdoSetTopic,
    BunnyUpload,
    CommonData,
    Profile,
    Courses,
    StudentEnroll,
    StudentEnrollDetail,
    ClassRoomType,
    ClassRoomOwned,
    ClassRoom,
    Degree,
    SubjectGroup,
    Subject,
    Faculty,
    Department,
    Curriculum,
    Prefix,
    Project,
    Assessment,
    StudentStatus,
    Student,
    Teacher,
    Staff,
    CourseOutline,
    CourseOutlineAssessment,
    CourseOutlineRegistration,
    AcademicPeriodConfig,
    AcademicPeriod,
    ClassSection,
    LiveClassSchedule,
    VdoLiveSet,
    VdoLiveSetTopic,
    Exam,
    ExamQuestion,
    ExamQuestionType,
    Upload,
    CourseOutlineUnit,
    User,
    AdvisorOnlineSchedule,
    InfoGroup,
    InfoTopic,
    YeaLinkImportDate,
    SystemConfig,
    ZoneGroup,
    Me,
    VdoMigration,
  },
  strict: process.env.NODE_ENV !== 'production'
})
